import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { CheckCircle } from 'react-feather';
function SellerRegisterSuccess(props){

    return (
        <>                                  
            <Helmet>
                <title>Account created successfully</title>
                <meta name="description" content={`Account created successfully`} />
            </Helmet>
            <section className="container mtopcon normal-mt-sctn">
                <div className="row">
                    <div className="col-12 col-lg-4 reglogincon">
                        <div className="card shadow-none">
                            <div className="card-body">                     
                                <form>
                                        
                                    <div className="row text-center mt-4">
                                        <div className="col-md-12 mb-2">
                                            <div className="btn btn-outline-success border-0"><CheckCircle width='100px' height='100px' /></div>
                                        </div>
                                        <div className="col-12">
                                            <h2 className='mb-3 text-center'><b>Success</b></h2>
                                            <p className='grey-text mb-4'>Congratulations, your account has been successfully created.</p>
                                            <Link className="main-btn bg-success btn-hover text-white mb-3" to="/seller/login">Proceed to Sign in</Link>
                                        </div>
                                    </div>
    
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SellerRegisterSuccess;